import { render, staticRenderFns } from "./fccHistoricoImportacoesPorRequisicoes.vue?vue&type=template&id=6f80d142"
import script from "./fccHistoricoImportacoesPorRequisicoes.vue?vue&type=script&lang=js"
export * from "./fccHistoricoImportacoesPorRequisicoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports